import { render, staticRenderFns } from "./ListItemRow.vue?vue&type=template&id=2edf5b3c&scoped=true&v-if=display&"
import script from "./ListItemRow.vue?vue&type=script&lang=ts&"
export * from "./ListItemRow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2edf5b3c",
  null
  
)

export default component.exports